export default [
	{
		modulo: 23,
		privilegio: 186,
		routerName: 'malha-voos',
		routerPath: '/malha-voos',
		componentName: 'MalhaVoos',
		componentPath: 'modules/layout/gestao-malha/voos/main'
	},
	{
		modulo: 23,
		privilegio: 186,
		routerName: 'malha-calendario-semanal',
		routerPath: '/malha-calendario-semanal',
		componentName: 'MalhaCalendarioSemanal',
		componentPath: 'modules/layout/gestao-malha/calendario-semanal/main'
	},
	{
		modulo: 23,
		privilegio: 186,
		routerName: 'malha-calendario-anual',
		routerPath: '/malha-calendario-anual',
		componentName: 'MalhaCalendarioAnual',
		componentPath: 'modules/layout/gestao-malha/calendario-anual/main'
	},
	{
		modulo: 23,
		privilegio: 186,
		routerName: 'malha-ordens-geradas',
		routerPath: '/malha-ordens-geradas',
		componentName: 'MalhaOrdensGeradas',
		componentPath: 'modules/layout/gestao-malha/ordens-geradas/main'
	}
]
